import styled, { css, StyledProps } from 'styled-components'
import { IconQuestion } from '../../iconography/Icons/Icons'
import { WizardTooltipPosition } from './WizardTooltip'

const positionCss = ({ position }: StyledProps<{ position: WizardTooltipPosition }>) => {
  const offset = '8px'
  switch (position) {
    case 'top':
      return css`
        left: 50%;
        top: 0;
        transform: translate(-50%, calc(-100% - ${offset}));
      `
    case 'right':
      return css`
        right: 0;
        top: 50%;
        transform: translate(calc(100% + ${offset}), -50%);
      `
    case 'bottom':
      return css`
        left: 50%;
        bottom: 0;
        transform: translate(-50%, calc(100% + ${offset}));
      `
    case 'left':
      return css`
        left: 0;
        top: 50%;
        transform: translate(calc(-100% - ${offset}), -50%);
      `
  }
}

export const WizardTooltipContainer = styled.div<{ position: WizardTooltipPosition }>`
  position: absolute;
  background-color: ${props => props.theme.color.primary100};
  opacity: 0.96;
  border-radius: 8px;
  padding: 4px 8px;
  z-index: ${props => props.theme.zIndex.tooltip};
  ${positionCss}

  width: 292px;
  top: -10px;
  left: 152px;
  position: absolute;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0px 0px 40px rgb(0 0 0 / 16%);
  color: ${props => props.theme.color.textPrimary};
  font-size: 12px;
  line-height: 16px;
  padding: 16px;
  text-align: left;

  ${props => props.theme.media.mobile`
  width: 124px;
  left: -54px;
`};
`

export const MatchingCard = styled.div`
  color: ${props => props.theme.color.textPrimary};
  font-weight: 500;
  padding: 8px;
  width: 186px;
  height: 104px;
  border-radius: 12px;
  background-color: ${props => props.theme.color.primary25};
  white-space: normal;
  text-align: center;
  cursor: pointer;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    background-color: ${props => props.theme.color.primary100};
  }

  ${props => props.theme.media.mobile`
    width: 124px;
    height: 80px;
  `}
`

export const MatchingBody = styled.div`
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;

  ${props => props.theme.media.mobile`
    font-size: 14px;
    line-height: 18px;
  `}
`

export const MatchingRecommendedTitle = styled.div`
  color: ${props => props.theme.color.primary200};
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  margin-top: -10px;
`

export const DescriptionIcon = styled.div`
  position: absolute;
  right: 2px;
  top: -16px;
`

export const StyledIconQuestion = styled(IconQuestion)`
  width: 16px;
  height: 16px;
`
